<script setup>
const props = defineProps({
  limit: {
    type: Number,
    default: 8,
  },
})

const config = useRuntimeConfig()
const url = config.public.apiBase + '/shop?include=media'
const { data, status, error } = await useLazyFetch(url)

const shops = computed(() => {
  const allShops = data.value?.data || []
  if (props.limit && props.limit > 0) {
    return allShops.slice(0, props.limit)
  }
  return allShops
})

const totalShopsCount = computed(() => data.value?.data?.length || 0)
</script>

<template>
  <div class="px-4 max-w-7xl mx-auto my-8">
    <div v-if="status === 'pending'">
      <NavLoading />
    </div>

    <div v-else-if="error" class="alert alert-error">
      Failed to load shops: {{ error.message }}
    </div>

    <div v-else>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
        <ShopCard 
          v-for="shop in shops"
          :id="shop.id"
          :key="shop.id"
          :type="shop.shop_type"
          :name="shop.name"
          :address="shop.address"
          :banner-url="shop.banner?.[0]?.original_url"
          :open-time="shop.opening_time"
          :close-time="shop.closing_time"
        />
      </div>

      <div v-if="limit && totalShopsCount > limit" class="flex justify-center mt-8">
        <NuxtLink to="/shops" class="btn btn-outline btn-primary px-8">
          View All Shops
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style scoped></style>